import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    const jumpToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    if (hash) {
      window.setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'auto', block: 'start' });
        } else {
          jumpToTop();
        }
      }, 50);
    } else {
      jumpToTop();
    }
  }, [pathname, hash, search]);

  return null;
};

export default ScrollToTop;
